import React from 'react'
import { ChangePlateProps } from './ChangePlate.types'
import styles from './ChangePlate.module.scss'
import cl from 'classnames'
import { HorizontalLine, Text1 } from 'components/shared'
import { LetterMark } from '../LetterMark'
import { Button } from '../Button'
import { User } from 'utilities'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'

const ChangePlateComponent = (props: ChangePlateProps) => {
  const {
    className,
    style,
    forceHideButtons,
    [AGREEMENT_PAGE_STORE]: {
      onRejectChangeClick,
      onAcceptChangeClick,
      isAgreementPendingApproval
    },
    ...versionChange
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <div className={styles.innerContainer}>
        <LetterMark
          letter={versionChange.markLetter}
          noBoxShadow
        />
        <Text1 className={styles.message}>
          {versionChange.message}
        </Text1>
      </div>

      {((User.isManager() || User.isShopOwner()) && !forceHideButtons && isAgreementPendingApproval) &&
        (<>
          <HorizontalLine />
          <div className={styles.buttonsContainer}>
            <Button
              preset='secondary'
              disabled={(
                versionChange.valueBeforeChange === undefined &&
                !versionChange.keyId.startsWith('project') &&
                !versionChange.keyId.startsWith('product')
              )}
              onClick={() => onRejectChangeClick(versionChange)}
            >
              Reject
            </Button>
            <Button
              preset='primary'
              disabled
            >
              Edit
            </Button>
            <Button
              preset='primary'
              onClick={() => onAcceptChangeClick(versionChange)}
            >
              Accept
            </Button>
          </div>
        </>)
      }

      <HorizontalLine />
    </div>
  )
}

const ChangePlate = inject(
  'AGREEMENT_PAGE_STORE'
)(ChangePlateComponent)
export { ChangePlate }
